import angular from 'angular';
import constants from 'app/constants';
import {
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';

import controller from './report-instance-status.controller';
import directive from './report-instance-status.directive';


export default angular.module('app.components.reports.generatedReports.reportInstanceStatus', [
  alerts,
  confirmDialog,
  constants,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
])
  .directive('grReportInstanceStatus', directive)
  .controller('GRReportInstanceStatusController', controller)
  .name;

console.log('app.components.reports.generatedReports.reportInstanceStatus created');
